/* istanbul ignore file */
import { boolean as codecBoolean, number as codecNumber, optional as codecOptional, string as codecString, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PatchAllowRegistrationDomainDataParser = 
/* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('allow')],
    ['tenantRoleId', codecNumber, 'tenant_role_id'],
    ['domain', /* #__PURE__ */ codecOptional(codecString)],
    [
        'matchSubdomains',
        /* #__PURE__ */ codecOptional(codecBoolean),
        'match_subdomains',
    ],
]);
export class PatchAllowRegistrationDomainData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PatchAllowRegistrationDomainDataParser.decode(input).map(res => new PatchAllowRegistrationDomainData(res));
    }
    static unsafeDecode(input) {
        return PatchAllowRegistrationDomainData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PatchAllowRegistrationDomainDataParser.encode(data);
    }
    static schema() {
        return PatchAllowRegistrationDomainDataParser.schema();
    }
}
